import USER_ROLES from '../../constants/userRoles.constants';

const DialogController = ($scope, $mdDialog) => {
    $scope.answer = function(answer) {
        $mdDialog.hide(answer);
    };
};


class HomeController {
    constructor($mdDialog, $location, $state, userService) {
        if(userService.currentUser) {
            this.currentUser = userService.currentUser;
            this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
        } else {
            userService.loadCurrentUser().then(user => {
                this.currentUser = user;
                this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
            });
        }

        this.startNewEvaluation = ev => {
            $mdDialog.show({
                controller: DialogController,
                template: require('./evaluationTypeDialog.html'),
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(answer => {
                switch (answer) {
                case 'full':
                    {
                        $location.path('/evaluation/basic-info');
                        break;
                    }
                case 'mini':
                    {
                        $location.path('/mini/basic-info');
                        break;
                    }
                }
            }).catch(() => {});
        };

        this.openMyProfile = () => {
            $state.go('user.profile', {id: this.currentUser.id});
        }
    }
}

HomeController.$inject = ['$mdDialog', '$location', '$state', 'UserService'];

export default HomeController;


// WEBPACK FOOTER //
// ./src/app/pages/home/homeController.js